import { Box, Flex, Text, Icon, Button, useToast } from "@chakra-ui/react";
import { PiEngineFill } from "react-icons/pi";
import { useConditionalBackground } from "@/contexts/useConditionalBackground";
import CustomDatePicker from "@/components/CustomDatePicker";
import { useState } from "react";
import { downloadBalanceSolicitationsExcel } from "@/services/consignado/balanceSolicitation.service";

export default function ConsignadoConsultCpfInputCard() {
  const backgroundStyle = useConditionalBackground();
  const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([null, null]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const toast = useToast()

  const handleDownloadExcel = async () => {
    try {
      if(!dateRange[0] || !dateRange[1]){
        toast({
          title: "Erro",
          description: "Selecione o intevalo de 1 dia",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
      
      const buffer = await downloadBalanceSolicitationsExcel({startDate: dateRange[0], endDate: dateRange[1]})
      const url = window.URL.createObjectURL(new Blob([buffer]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Consultas_${dateRange[0]}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      toast({
        title: "Sucesso",
        description: "Download realizado com sucesso.",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
      } catch (error: any) {
        let description = "Erro ao fazer download, tente novamente."
        console.error('error aqui', error);
        if(error?.status === 404){
          description = 'Sem registros para a data selecionada.'
        }
         toast({
          title: "Erro",
          description,
          status: "error",
          duration: 3000,
          isClosable: true,
        });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box width={"100%"}>
      <Box
        {...backgroundStyle}
        borderRadius="md"
        p={{ base: 4, md: 6 }}
        color="white"
        h="100%"
        boxShadow="md"
      >
        <Flex
          alignItems="center"
          flexDirection={{ base: "column", md: "row" }}
          textAlign={{ base: "center", md: "left" }}
        >
          <Icon as={PiEngineFill} boxSize={{ base: 10, md: 8, lg: 8 }} />
          <Text
            fontSize={{ base: "3xl", md: "2xl", lg: "4xl" }}
            fontWeight="bold"
            ml={{ base: 0, md: 4 }}
            mt={{ base: 3, md: 0 }}
            fontFamily="Lexend Deca"
          >
            Motor Análise de Crédito
          </Text>
        </Flex>

        <Flex gap={4} alignItems="center" flexWrap="wrap" mt={10}>
          <CustomDatePicker
            dateRange={dateRange}
            onChange={(dates) => setDateRange(dates)}
            maxDays={1}
          />

          <Button
            color="white"
            colorScheme="green"
            textTransform="uppercase"
            onClick={handleDownloadExcel}
            isLoading={isLoading}
            isDisabled={!dateRange[0] || !dateRange[1]}
          >
            Gerar Relatório Diário
          </Button>
        </Flex>
      </Box>
    </Box>
  );
}
